module.exports = __webpack_public_path__ + "img/we-value-image-1.d22564c3.png";